// extracted by mini-css-extract-plugin
export default {"block":"LessonView_block__Jtzsh","photo":"LessonView_photo__8PiMK","info":"LessonView_info__OrvTV","title":"LessonView_title__o-L51","text":"LessonView_text__PpWBf"};